import { Release } from '../../../../common/types/release/release';
import moment from 'moment';

export const getPreorderDate = (release: Release) => {
  if (!(release.hasPreorder && release.preorderDate)) {
    return 'No Pre-order'
  }

  return moment(release.preorderDate).format('LL')
}